// extracted by mini-css-extract-plugin
export default {"root":"DomainList-root_X9Tez","container":"DomainList-container_uJnIk","list":"DomainList-list_ca0jB"};